document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector("#infinite-scroll-container");
  const trigger = document.querySelector("#infinite-scroll-trigger");
  const loader = document.querySelector("#infinite-scroll-loader");
  if (!container || !trigger || !loader) return;

  // Optional vorhandene Pagination ausblenden
  document.querySelectorAll(".collection__pagination, nav.pagination").forEach(el => {
    el.style.display = "none";
  });

  // ---- Helpers: Karten finden & Schlüssel bestimmen ----
  const getCardEls = (root) => [
    ...root.querySelectorAll(".product-card-wrap, [data-product-id], [data-product-handle]")
  ];

  const getCardKey = (el) => {
    const id = el.dataset?.productId;
    if (id) return "id:" + id;
    const handle = el.dataset?.productHandle;
    if (handle) return "h:" + handle;
    const a = el.querySelector('a[href*="/products/"]');
    if (a) {
      try {
        const u = new URL(a.getAttribute("href"), window.location.origin);
        return "u:" + u.pathname.replace(/\/$/, "");
      } catch {
        return "u:" + a.getAttribute("href").replace(/\/$/, "");
      }
    }
    return null; // kein Key -> Karte bleibt unangetastet
  };

  const dedupe = (root) => {
    const seen = new Set();
    const cards = getCardEls(root);
    for (const el of cards) {
      const key = getCardKey(el);
      if (!key) continue;               // ohne Key: nie entfernen
      if (seen.has(key)) el.remove();   // Duplikat: späteres löschen
      else seen.add(key);               // erstes Vorkommen behalten
    }
  };

  // ---- Next-URL Ermittlung (ohne sichtbare Pagination) ----
  const getHeadNext = (doc) => doc.querySelector('link[rel="next"]')?.href || null;

  const getPage = (url) => {
    try {
      const u = new URL(url, window.location.origin);
      const p = parseInt(u.searchParams.get("page") || "1", 10);
      return Number.isNaN(p) ? 1 : p;
    } catch { return 1; }
  };

  const setPage = (base, page) => {
    const u = new URL(base, window.location.origin);
    if (page <= 1) u.searchParams.delete("page");
    else u.searchParams.set("page", String(page));
    return u.toString();
  };

  const baseUrl = (() => {
    const u = new URL(window.location.href);
    u.searchParams.delete("page");
    return u.toString();
  })();

  let nextUrl =
    document.querySelector('.collection__pagination a[rel="next"], nav.pagination a[rel="next"]')?.href ||
    getHeadNext(document) ||
    setPage(baseUrl, getPage(window.location.href) + 1);

  const loadedUrls = new Set([window.location.href]);
  let loading = false;

  // Beim Start einmal deduplizieren (falls initial schon Duplikate da sind)
  dedupe(container);

  const io = new IntersectionObserver(
    (entries) => { if (entries.some(e => e.isIntersecting)) loadMore(); },
    { rootMargin: "1000px", threshold: 0.01 }
  );
  io.observe(trigger);

  function loadMore() {
    if (!nextUrl || loading) return;
    if (loadedUrls.has(nextUrl)) return;

    loading = true;
    loader.style.display = "block";
    io.unobserve(trigger);

    const thisUrl = nextUrl;

    fetch(thisUrl)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const incoming =
          doc.querySelector("#infinite-scroll-container") ||
          doc.querySelector(".product-list");
        if (!incoming) {
          nextUrl = null;
          io.disconnect();
          return;
        }

        const before = container.children.length;
        container.insertAdjacentHTML("beforeend", incoming.innerHTML);

        // Nach dem Einfügen deduplizieren (nur spätere Duplikate entfernen)
        dedupe(container);

        loadedUrls.add(thisUrl);

        // Nächste Seite bestimmen
        const headNext = getHeadNext(doc);
        if (headNext) nextUrl = headNext;
        else nextUrl = setPage(baseUrl, getPage(thisUrl) + 1);

        const after = container.children.length;
        if (!nextUrl || after <= before) {
          // Keine neue Seite oder nichts Neues -> Ende
          nextUrl = null;
          io.disconnect();
          return;
        }

        // Direkt weiterladen, wenn Trigger noch nah am Viewport
        requestAnimationFrame(() => {
          const r = trigger.getBoundingClientRect();
          const nearlyVisible = r.top - window.innerHeight < 800;
          if (nearlyVisible) {
            loading = false;
            loader.style.display = "none";
            loadMore();
          } else {
            io.observe(trigger);
          }
        });
      })
      .catch(err => {
        console.error("Infinite scroll error:", err);
        io.disconnect();
      })
      .finally(() => {
        loader.style.display = "none";
        loading = false;
      });
  }
});
